import {Component, Input, OnInit} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {MyDeviceRequestContainerModel} from '../../../models/my-device-request-container.model';
import {SupplyAcquisitionTypeEnum} from '../../../enums/supply-acquisition-type.enum';
import {RPriceInfoModel} from '../../../models/r-price-info.model';
import {PriceInfoModel} from '../../../models/price-info.model';
import {EditModalCustomPriceTableService} from '../../../services/edit-modal-custom-price-table.service';
import {SmallTextInfoModalComponent} from '../../small-text-info-modal/small-text-info-modal.component';
import {ModalVisibilityService} from '../../../services/modal-visibility.service';
import {MyPageRPricesSelectBase} from '../../../enums/my-page-rprices-select-base.enum';
import {ProductModel} from '../../../models/product.model';
import {ModalDynamicV3Service} from '../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';


// component used on 5.page on printSmart tab
@Component({
    selector: 'app-projects-print-smart-supplies-shopping-table',
    templateUrl: './print-smart-supplies-shopping-table.component.html',
    styleUrls: ['./print-smart-supplies-shopping-table.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ProjectsPrintSmartSuppliesShoppingTableComponent extends EditModalSectionBaseComponent implements OnInit {

    // public ShoppingModeEnum = MySupplySoppingModeEnum;
    @Input() public forceFormValidationVisibility: boolean;
    public supplyAcquisitionTypeEnum = SupplyAcquisitionTypeEnum;
    // private modalVisibilitySub: Subscription;
    private dialogRef: IModalDialogV3;


    constructor(public  editModalService: EditModalService,
                private editModalCustomPriceTableService: EditModalCustomPriceTableService,
                private modalDynamicV3Service: ModalDynamicV3Service,
                private modalVisibilityService: ModalVisibilityService) {
        super(editModalService);
    }


    public async ngOnInit() {
        super.ngOnInit();
    }


    // returns all printSmart devices already selected/requested on dialog 3.step which contains supplies, so the user can
    // select/confirm supplies request for this device on this table
    public getAvailablePrintSmartDeviceWithSupplyContainers(): MyDeviceRequestContainerModel[] {
        return this.model.availablePreselectedPrintSmartDevicesWithSupplyContainers;
    }

    public getSupplyAcquisitionMode(): SupplyAcquisitionTypeEnum {
        return SupplyAcquisitionTypeEnum[this.model.project.supplyAcquisitionType];
    }

    public isInternalUser(): boolean {
        // return false;
        return false;
    }

    public getExtendedRPriceChoices(priceInfos: RPriceInfoModel[] ): string[] {
        return this.editModalCustomPriceTableService.getExtendedRPriceChoices(priceInfos);
    }

    public getExtendedRPriceValues(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedRPriceValues(priceInfos);
    }


    public onPriceTypeChanged(priceInfo: PriceInfoModel) {
        return this.editModalCustomPriceTableService.onPriceTypeChanged(priceInfo);
    }


    public isSelectedPriceTypeEqualOtherPrice(priceType: string): boolean {
        return this.editModalCustomPriceTableService.isSelectedPriceTypeEqualOtherPrice(priceType);
    }

    public priceNoteShouldBeVisible(priceType: string): boolean {
        return this.editModalCustomPriceTableService.priceNoteShouldBeVisible(priceType);
    }


    public openDisabledInputInfoPanel(elementRef: HTMLElement, deltaX = 0) {


        // console.log('openDisabledInputInfoPanel');

        this.modalVisibilityService.announceCloseEditDialogModalsRequest('before_openDisabledInputInfoPanel');

        const dialogHeight = 109;
        const deltaY = 0;

        const top = Math.floor(+elementRef.getBoundingClientRect().top) + deltaY;
        const left = Math.floor(+elementRef.getBoundingClientRect().right) + deltaX;


        this.dialogRef = this.modalDynamicV3Service
            .open(SmallTextInfoModalComponent, {
                model: {
                    title: 'Achtung!',
                    messages: ['Der Stückpreis wurde bei dem Verbrauchsmaterial bereits ausgewählt.'],
                    top: top,
                    left: left,
                    showCloseBtn: false,
                    minHeight: dialogHeight,
                    closeEvent: this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$
                }
            }, true);

        // this.modalVisibilitySub = this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$.subscribe(_ => {
        //
        //     if (this.dialogRef) {
        //         this.closeInfoPanel();
        //     }
        // });
    }

    public closeInfoPanel() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
        // if (this.modalVisibilitySub) {
        //     this.modalVisibilitySub.unsubscribe();
        // }
        this.dialogRef = undefined;
        // this.modalVisibilitySub = undefined;
    }



    public getExtendedPagePriceChoices(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedPagePriceChoices(priceInfos);

    }

    public getExtendedPagePriceValues(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedPagePriceValues(priceInfos);
    }

    public isSelectedPagePriceTypeEqualCustomPrice(selectedPrice: string): boolean {
        return MyPageRPricesSelectBase[selectedPrice] === MyPageRPricesSelectBase.CUSTOM;
    }

    public pagePriceNoteShouldBeVisible(devicePagePrices: { mono: PriceInfoModel; color: PriceInfoModel }) {
        return MyPageRPricesSelectBase[devicePagePrices.mono.selectedPrice] === MyPageRPricesSelectBase.CUSTOM ||
            MyPageRPricesSelectBase[devicePagePrices.color.selectedPrice] === MyPageRPricesSelectBase.CUSTOM;
    }

    public onPagePriceTypeChanged(devicePagePrices: { mono: PriceInfoModel; color: PriceInfoModel }) {
        if (!this.pagePriceNoteShouldBeVisible(devicePagePrices)) {
            console.log('mono and color page price note going be removed... removed note:', devicePagePrices.color.customPriceInfo.customPriceComment);
            // color customPriceComment is use to store comment for both prices color and mono.
            devicePagePrices.color.customPriceInfo.customPriceComment = '';
            devicePagePrices.mono.customPriceInfo.customPriceComment = null;
        }
    }

    public onSetPriceBtnClicked() {
        this.editModalService.set5pageSuppliesPrices();
    }

    public showValidationError(): boolean {
        return  this.forceFormValidationVisibility && !this.editModalService.projectContainsAnythingToOrder();
    }

    // public ngOnDestroy(): void {
    //     if (this.modalVisibilitySub) {
    //         this.modalVisibilitySub.unsubscribe();
    //     }
    // }

    public isColorPrinter(printer: ProductModel ):boolean {
        return this.editModalService.containerUtilsService.isColorPrinter(printer);
    }
}
